import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import HarvestAndPlantingMap from '../HarvestAndPlantingMap';
import { getCurrentSeason } from '../../../../selectors';

function PlantingMap(props) {
  return <HarvestAndPlantingMap {...props} />;
}

PlantingMap.propTypes = {
  crop: PropTypes.string.isRequired,
  dates: PropTypes.object.isRequired,
};

export function mapStateToProps(state, props) {
  const activeSeason = getCurrentSeason(state, props);
  const { cropCustomName, plantingEndDate, plantingStartDate, plantingYear } =
    state.seasons.list?.[activeSeason] ?? {};
  const dates = {
    endDate: plantingEndDate,
    startDate: plantingStartDate,
    year: plantingYear,
  };

  return {
    crop: cropCustomName ?? '',
    dates,
  };
}

export default connect(mapStateToProps)(PlantingMap);
